"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlacklistButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const blacklist_json_1 = __importDefault(require("@framework/abis/json/ERC20Blacklist/blacklist.json"));
const dialogs_1 = require("../../../dialogs");
const utils_1 = require("../../../utils");
const validation_1 = require("../../../dialogs/account/validation");
const BlacklistButton = (props) => {
    const { className, contract, contract: { accessControls, address, contractFeatures }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog, closeDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: address,
            abi: blacklist_json_1.default,
            functionName: "blacklist",
            args: [values.account],
        });
    });
    const handleBlacklistConfirmed = async ({ data }) => {
        await metaFn(data).finally(() => {
            closeDialog();
        });
    };
    const handleBlacklist = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ACCOUNT, contract, {
            initialValues: {
                account: "",
            },
            validationSchema: validation_1.accountDialogValidationSchema,
            message: "dialogs.blacklist",
            testId: "AccessListBlacklistForm",
            onExternalConfirm: handleBlacklistConfirmed,
        });
    };
    if (!contractFeatures.includes(types_1.ContractFeatures.BLACKLIST)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleBlacklist, icon: icons_material_1.DoNotDisturbOn, message: "form.buttons.blacklist", className: className, dataTestId: "BlacklistButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }));
};
exports.BlacklistButton = BlacklistButton;
//# sourceMappingURL=index.js.map